import { NextRequest, NextResponse } from 'next/server';
import type CurrencyCode from '@alltrails/types/CurrencyCode';
import { getPurchaseEventId, getSignupEventId, getTrialStartEventId } from './conversionsApi';

const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000;
const CLICK_ID_QUERY_PARAM_NAME = 'rdt_cid';
const CLICK_ID_COOKIE_NAME = '_rdt_cid';

// https://business.reddithelp.com/s/article/manual-conversion-events-with-the-reddit-pixel
export const trackPurchaseForReddit = ({
  userId,
  currencyCode,
  value,
  isTrial,
  subscription_event_id
}: {
  userId: number;
  currencyCode: CurrencyCode;
  value: number;
  isTrial: boolean;
  subscription_event_id?: number;
}) => {
  if (isRedditPixelUnavailable() || !subscription_event_id) {
    return;
  }

  if (isTrial) {
    rdt('track', 'TrialStart', {
      conversionId: getTrialStartEventId(subscription_event_id),
      externalId: userId
    });
  } else {
    rdt('track', 'Purchase', {
      currency: currencyCode,
      value,
      conversionId: getPurchaseEventId(subscription_event_id),
      externalId: userId
    });
  }
};

export const trackCompleteRegistrationForReddit = (userId: number, currencyCode?: CurrencyCode | null) => {
  if (isRedditPixelUnavailable()) {
    return;
  }

  rdt('track', 'SignUp', { conversionId: getSignupEventId(userId), externalId: userId, currency: currencyCode || 'USD' });
};

export const setRedditCookiesMiddleware = (request: NextRequest, response: NextResponse) => {
  const { searchParams } = request.nextUrl;
  const redditClickIdParam = searchParams.get(CLICK_ID_QUERY_PARAM_NAME);
  const ninetyDaysFromNow = new Date(Date.now() + NINETY_DAYS_MS);

  if (redditClickIdParam) {
    response.cookies.set({
      name: CLICK_ID_COOKIE_NAME,
      value: redditClickIdParam,
      expires: ninetyDaysFromNow,
      domain: process.env.APEX_DOMAIN!,
      secure: true
    });
  }
};

// Check for presence of rdt in case of content blockers
const isRedditPixelUnavailable = () => {
  return typeof rdt === 'undefined';
};
